<template>
	<div class="display-flex height-100 flex-centerize">
		<div class="slot-card flex-column flex-centerize px-6 py-12">
			<img v-if="logoUrl" :src="logoUrl" class="logo mb-6" />
			<h1 class="font-weight-bold slot-title mb-2">{{ requestCodeText || 'Welcome!' }}</h1>
			<p class="font-weight-bold">We need to verify it's you to continue</p>
			<v-form @submit.prevent="submitForm" v-model="isFormValid" class="user-input-box mt-6 width-100" ref="form">
				<SignupTextField
					label="Please enter your email"
					iconName="email"
					:rules="emailRules"
					v-model="email"
					type="email"
					autofocus
					single-line
					placeholder="your@email.com"
				/>
				<AnemicButton :disabled="!this.isFormValid" type="submit" class="continue-button width-100 my-4">Next</AnemicButton>
			</v-form>
		</div>
	</div>
</template>

<script>
import SignupTextField from '@/views/userRegistration/components/SignupTextField';
import UserRegistrationService from '@/views/userRegistration/helpers/UserRegistrationService';

export default {
	name: 'PortalAuthRequestCode',
	props: { requestCodeText: { type: String, required: true }, prefillEmail: { type: String }, logoUrl: { type: String } },
	components: {
		SignupTextField,
	},
	methods: {
		submitForm() {
			this.$refs.form.validate();
			if (this.isFormValid) {
				this.$emit('email-submitted', this.email);
			}
		},
	},
	async mounted() {},
	data() {
		return {
			email: this.prefillEmail || '',
			isFormValid: false,
			requiredRules: UserRegistrationService.getRequiredRules(),
			emailRules: UserRegistrationService.getEmailValidationRules(),
		};
	},
};
</script>

<style scoped lang="scss">
.continue-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: white;
	background: var(--bold-border-color) !important;
	border: 1px solid var(--bold-border-color);
}
.slot-card {
	min-width: 470px;
	max-width: 760px;
	text-align: center;
	border-radius: 28px;
	background: var(--bg-color);
	@media (max-width: 600px) {
		min-width: calc(100% - 20px);
		max-width: calc(100% - 20px);
		padding: 18px 10px 28px 10px;
	}
	box-shadow: 0px 13px 30px 0px #00000040;
}
.logo {
	max-width: 50px;
}
</style>
